import React from "react";
import { GridColDef } from "@mui/x-data-grid-premium";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, Box } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import NihssScoreRows from "../model";
import Grid from "@mui/material/Unstable_Grid2";
import NihssScoreCreate from "../create";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";

const columns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return (
        <Link to={`edit/${params.row.id}`}>
          <EditIcon color="info" />
        </Link>
      );
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];

function NihssScoreList() {
  return (
    <BaseMedCardList
      title="Nihss Skoru"
      columns={columns}
      rows={NihssScoreRows}
      CreateComponent={NihssScoreCreate}
      pageSize={10}
    >
      <Box sx={{ padding: "20px" }}>
        <Grid container spacing={2}>
          <Grid md={9} xs={9} container direction={"column"} spacing={3}>
            <Grid md={9} xs={9}>
              <ByzMuiTypography
                sx={{
                  whiteSpace: "pre-line",
                  fontWeight: "bold",
                  marginBottom: 2,
                }}
              >
                Soru 9 İçin:
              </ByzMuiTypography>
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={12}>
                <ByzMuiTypography
                  sx={{ whiteSpace: "pre-line", marginBottom: 2 }}
                >
                  Resimde Neler Olduğunu Anlatınız.
                </ByzMuiTypography>
                <img
                  src="/assets/images/medcards/nihss-score/question-9-1.png"
                  alt="Soru 9 Görsel"
                  style={{ maxWidth: "320px" }}
                />
              </Grid>

              <Grid md={6} xs={12}>
                <ByzMuiTypography
                  sx={{ whiteSpace: "pre-line", marginBottom: 2 }}
                >
                  Resimdeki Nesnelerin İsimleri Ne.
                </ByzMuiTypography>
                <img
                  src="/assets/images/medcards/nihss-score/question-9-2.png"
                  alt="Soru 9 Nesneler"
                  style={{ maxWidth: "320px" }}
                />
              </Grid>
            </Grid>

            <Grid md={6} xs={6}>
              <ByzMuiTypography
                sx={{ whiteSpace: "pre-line", marginBottom: 2 }}
              >
                {`Soru 9 İçin Okutunuz:
            • Nasıl Olur Bilirsin.
            • Ben İşten Eve Döndüm.
            • Gerçekçi Bir İnsan.
            • Yemek Odasında Masanın Üstünde.
            • Dün Gece Onun Radyoda Konuştuğunu Duymuşlar.`}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6}>
              <ByzMuiTypography
                sx={{ whiteSpace: "pre-line", marginBottom: 2 }}
              >
                {`Soru 10 İçin Tekrarlatınız:
            • Baba
            • Tıptıp
            • Hafta Hafta
            • Tarife
            • Kahverengi
            • Futbol Meraklısı`}
              </ByzMuiTypography>
            </Grid>
            <Grid md={12} xs={12}>
              <ByzMuiTypography sx={{ whiteSpace: "pre-line" }}>
                {`Ulusal Sağlık İnme Ölçeği (NIHSS) En Yaygın Olarak İnmenin Şiddetini Ölçmek İçin Kullanılır ve 0 ile 42 Arasında Değişen Bir Puana Sahiptir.
            NIHSS İnme Ölçeği, Bilinç, Görme, Duyu, Hareket,
            Konuşma ve Dil Dahil Olmak Üzere Beyin Fonksiyonlarının Çeşitli Yönlerini Ölçer. Odaklanmış Bir Nörolojik Muayene Sırasında Bu Fiziksel ve Bilişsel İşlevlerin 
            Her Biri İçin Belli Sayıda Puan Verilir.
            
            En Yüksek 42 Skoru En Şiddetli ve Yüksek İnme'yi Göstermektedir. NIH İnme Skalası Skorlama Sistemi İle Ölçülen İnme Şiddet Derecesi:

            • 0 = Vuruş Yok
            • 1-4 = Küçük İnme
            • 5-15 = Orta Vuruş
            • 15-20 = Orta / Şiddetli İnme
            • 21-42 = Şiddetli İnme`}
              </ByzMuiTypography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </BaseMedCardList>
  );
}

export default NihssScoreList;
